import { RadioGroup, Select } from '../../../itrust_common/components/form'
import { change, Field } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'

function TabAppointment(props) {
  const { staffs, tab_appointment, tabConfig, tabAddOnCred, tabMapperStatus, isNew } = props
  const [showTAB, setShowTAB] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    setShowTAB(((tabConfig?.status && tabConfig?.status !== 'inactive') && (tabAddOnCred?.status && tabAddOnCred?.status == 'success' && tabMapperStatus !== 'pending') && !tab_appointment))
  }, [])

  useEffect(() => {
    if (showTAB && !tab_appointment && isNew) {
      dispatch(change('appointmentForm', 'tab_appointment', true))
    }
  }, [showTAB])

  return (
    <div className='row mx-0 align-items-end mt-4'>
      {showTAB && <RadioGroup name="tab_appointment" options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]} wrapperClasses={`${showTAB ? 'col-4' : 'col-12'} form-group`} label="TAB Sync" />}
      <Field label="Provider" name="staff_id" placeholder="Provider" component={Select} textField="name" valueField="id" data={staffs} wrapperClasses={`${showTAB ? 'col-8 pl-0' : 'col-12 px-3'} form-group`} />
    </div>
  )
}

const mapStateToProps = state => {
  const { organisation: { organisation }, tab } = state
  return {
    tabConfig: organisation?.add_ons_config?.type?.tab,
    tabAddOnCred: tab.tab_add_on?.config?.creds,
    tabMapperStatus: tab.tabMapperStatus,
  }
}

export default connect(mapStateToProps)(TabAppointment);